export default ({ color = '#001335', style }) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M4 12.0711C4.17475 14.2036 5.86743 15.8963 7.99999 16.0711C5.86743 16.2458 4.17475 17.9385 4 20.0711C3.82525 17.9385 2.13257 16.2458 7.55476e-06 16.0711C2.13257 15.8963 3.82525 14.2036 4 12.0711Z"
      fill={color}
    />
    <path
      d="M13 0C13.3089 3.76989 16.3012 6.76216 20.0711 7.07107C16.3012 7.37998 13.3089 10.3723 13 14.1421C12.6911 10.3723 9.69882 7.37998 5.92893 7.07107C9.69882 6.76216 12.6911 3.76989 13 0Z"
      fill={color}
    />
  </svg>
)
